import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams, AlertController } from '@ionic/angular';
import { EventService } from '../../services/event.service';
import { ObserverService } from '../../services/observer.service';
import * as moment from 'moment-timezone';
import { SelectEventSessionTicketTypePage } from '../select-event-session-ticket-type/select-event-session-ticket-type.page';

@Component({
    selector: 'app-select-event-session',
    templateUrl: './select-event-session.page.html',
    styleUrls: ['./select-event-session.page.scss'],
})
export class SelectEventSessionPage implements OnInit {

    moment = moment;
    event_id = null;
    event = null;
    sessions = null;

    constructor(
        public modalController: ModalController,
        public navParams: NavParams,
        public alertController: AlertController,
        private eventService: EventService,
        private observerService: ObserverService
    ) { }

    ngOnInit() {
        
        if (this.navParams.get("event_id")) {
            this.event_id = this.navParams.get("event_id");
        }

        this.eventService.getEvent(this.event_id).then((event) => {
            this.event = event;
        });

        this.eventService.getEventSessions(this.event_id).then((sessions: any) => {
            if (this.event.allow_session_dates) {
                sessions.sort((a, b) => {
                    if (a.start_date < b.start_date) { return -1; }
                    if (a.start_date > b.start_date) { return 1; }
                    return 0;
                });
            }
            else {
                sessions.sort((a, b) => {
                    if (a.order < b.order) { return -1; }
                    if (a.order > b.order) { return 1; }
                    return 0;
                });

            }
            this.sessions = sessions;
        });

        this.observerService.subscribe('event_session_added|select_event_session_modal', (session) => {
            if (session) {
                this.sessions.push(session);
                // NOTE: we don't re-sort at this point, as it would clause jank
            }
        });

        this.observerService.subscribe('event_session_deleted|select_event_session_modal', (session) => {
            if (session) {
                for (let i = 0; i < this.sessions.length; i++) {
                    if (this.sessions[i].id === session["id"]) {
                        this.sessions.splice(i, 1);
                        break;
                    }
                }
            }
        });

        this.observerService.subscribe('event_session_updated|select_event_session_modal', (session) => {
            if (session) {
                for (let i = 0; i < this.sessions.length; i++) {
                    if (this.sessions[i].id === session["id"]) {
                        this.sessions[i] = session;
                        break;
                    }
                }
            }
        });

    }

    ngOnDestroy() {
        this.observerService.destroy("event_session_added|select_event_session_modal");
        this.observerService.destroy("event_session_deleted|select_event_session_modal");
        this.observerService.destroy("event_session_updated|select_event_session_modal");
    }

    close() {
        this.modalController.dismiss();
    }

    async presentSelectSessionTicketTypeModal(event, session) {
        const modal = await this.modalController.create({
            component: SelectEventSessionTicketTypePage,
            componentProps: {
                event_id: event.id,
                session_id: session.id
            }
        });
        return await modal.present();
    }

}
